import VariantUnifiedResourceInstance from "../../../../resources/expapiunified/Variant.unified.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  VariantUnifiedResourceInstance,
  "variants",
  (state) => state.variants
);
const {
  actions: updateCompositionActions,
  selectAsyncRequest: selectUpdateCompositionAsyncRequest,
  isOfType: isUpdateComposition
} = builder.addMiscellaneousAction(
  "UPDATE_COMPOSITION",
  (inputPayload) => VariantUnifiedResourceInstance.updateCompositionAsync(inputPayload.workspaceId, inputPayload.id, inputPayload.entity)
);
const updateCompositionAsync = (workspaceId, variantId, compositionGraph) => updateCompositionActions.load({ workspaceId, id: variantId, entity: compositionGraph });
const resetUpdateCompositionAsync = (workspaceId, variantId) => updateCompositionActions.reset({ workspaceId, id: variantId, entity: void 0 });
const {
  actions: getCompositionActions,
  selectAsyncRequest: selectGetCompositionAsyncRequest,
  isOfType: isGetComposition
} = builder.addMiscellaneousAction(
  "GET_COMPOSITION",
  (inputPayload) => VariantUnifiedResourceInstance.getCompositionAsync(inputPayload.workspaceId, inputPayload.id)
);
const { load: getCompositionAsync, reset: resetGetCompositionAsync } = getCompositionActions;
const {
  epic: variantsEpic,
  reducer: variantsReducer,
  actions: variantsActions,
  matchers: variantsMatchers,
  selectors,
  getDefaultReducerState: getDefaultVariantsReducerState
} = builder.create();
const {
  selectAll: selectAllVariants,
  selectById: selectVariantById,
  selectGetAsyncRequest: selectGetVariantAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateVariantAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteVariantAsyncRequest,
  selectQueryAsyncRequest: selectQueryVariantsAsyncRequest
} = selectors;
const {
  getAsync: getVariantAsync,
  createOrUpdateAsync: createOrUpdateVariantAsync,
  deleteAsync: deleteVariantAsync,
  queryAsync: queryVariantsAsync,
  resetGetAsync: resetGetVariantAsync,
  resetCreateOrUpdateAsync: resetCreateOrUpdateVariantAsync,
  resetDeleteAsync: resetDeleteVariantAsync,
  resetQueryAsync: resetQueryVariantsAsync
} = variantsActions;
export {
  createOrUpdateVariantAsync,
  deleteVariantAsync,
  getCompositionAsync,
  getDefaultVariantsReducerState,
  getVariantAsync,
  isGetComposition,
  isUpdateComposition,
  queryVariantsAsync,
  resetCreateOrUpdateVariantAsync,
  resetDeleteVariantAsync,
  resetGetCompositionAsync,
  resetGetVariantAsync,
  resetQueryVariantsAsync,
  resetUpdateCompositionAsync,
  selectAllVariants,
  selectCreateOrUpdateVariantAsyncRequest,
  selectDeleteVariantAsyncRequest,
  selectGetCompositionAsyncRequest,
  selectGetVariantAsyncRequest,
  selectQueryVariantsAsyncRequest,
  selectUpdateCompositionAsyncRequest,
  selectVariantById,
  updateCompositionAsync,
  variantsEpic,
  variantsMatchers,
  variantsReducer
};
//# sourceMappingURL=variants.js.map
